export let CoordinateType;(function(e){e[e["GEODETIC"]=1]="GEODETIC";e[e["CARTESIAN"]=2]="CARTESIAN"})(CoordinateType||(CoordinateType={}));